import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContentContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      color: '#FFF',
      '& svg': {
        fontSize: '60px',
      },
    },
    dialogContent: {
      padding: theme.spacing(2),
    },
    typographyDefault: {
      color: theme.palette.text.primary,
    },
    feedbackDialogButton: {
      background: '#FFF',
      color: theme.palette.text.secondary,
    },
    dialogTitleText: {
      fontSize: 18,
      fontWeight: 'bold',
      color: theme.palette.background.paper,
    },
    dialogDescription: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
  }),
);

export default useStyles;
